import CustomsBrokerRegistry from "../CustomsBrokerRegistry";
import { hasPermission } from "../../permissions";

/* ============================================================================
 * ShipperBrokers — thin wrapper around the admin CustomsBrokerRegistry.
 * Passes shipperMode=true so the registry restricts to Mexican brokers,
 * and threads granular permission flags so the registry hides Add /
 * Edit / Delete actions when the logged-in user lacks them. The admin
 * accesses the same component with no flags → defaults to canX=true.
 * ============================================================================ */
export default function ShipperBrokers({ lang, profile }) {
  return (
    <CustomsBrokerRegistry
      lang={lang}
      shipperMode={true}
      canCreate={hasPermission(profile, "create_brokers")}
      canEdit={hasPermission(profile, "edit_brokers")}
      canDelete={hasPermission(profile, "delete_brokers")}
    />
  );
}
